<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col
        lg="12"
        style="display:block; text-align:center;padding-bottom:15px;font-size:1.2em;"
        v-if="total > 0"
      >
        <span style="padding:5px;">Total Records:</span>
        <b style="border-right:1px solid white; padding-right:5px;">{{
          total
        }}</b>
        <span style="padding:5px;">Total Price:</span>
        <b
          >${{
            totalPrice.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
          }}</b
        >

        <b-button
          class="download-button"
          variant="primary"
          size="lg"
          @click="downloadExcel()"
        >
          <div style="display:inline-block;" v-if="loading2019" class="loading">
            <b-row>
              <b-col lg="12">
                <div class="sk-double-bounce bouncing2">
                  <div class="sk-child sk-double-bounce1"></div>
                  <div class="sk-child sk-double-bounce2"></div>
                </div>
              </b-col>
            </b-row>
          </div>

          <i v-else class="fa fa-file-excel-o" aria-hidden="true"></i>
          Download
        </b-button>
      </b-col>
      <b-col lg="12">
        <c-table :table-data="data" :fields="fields" :caption="title"></c-table>
        <div v-show="loading" class="sk-double-bounce">
          <div class="sk-child sk-double-bounce1"></div>
          <div class="sk-child sk-double-bounce2"></div>
        </div>
      </b-col>
    </b-row>
    <!--/.row-->
  </div>
</template>

<script>
import router from "../../router";
import { allowedPath } from "../../shared/utils";
import cTable from "./Table.vue";

export default {
  props: [
    "location",
    "productGroup",
    "type",
    "date_from",
    "date_to",
    "productModel",
    "prg",
    "clients"
  ],
  name: "tables",
  components: { cTable },
  data: () => {
    return {
      locationParam: "",
      excelDownload: "",
      loading2019: false,
      loadingExcel: false,
      clientsId: "",
      productGroupParam: "",
      dateFromParam: "",
      modelParam: "",
      dateToParam: "",
      title: "",
      loading: true,
      data: [],
      total: 0,
      totalPrice: 0,
      fields: [
        { key: "locat", label: "Location" },
        { key: "fnsid", label: "FNSID", sortable: true },
        { key: "invno", label: "Invoice #" },
        { key: "originalRa", label: "Original RA" },
        { key: "fnsra", label: "New RA" },
        {
          key: "pMake",
          label: "Manufacturer",
          sortable: true,
          style: "width: 250px"
        },
        { key: "family", label: "Family" },
        { key: "pMode", label: "Model" },
        { key: "sernm", label: "Serial Number" },
        { key: "recvD", label: "Received" },
        { key: "shipd", label: "Shipped" },
        { key: "charteritem", label: "Item Master #" },
        { key: "newsapm", label: "NewSAP MM" },
        { key: "price", label: "Price", sortable: true }
      ]
    };
  },
  methods: {
    downloadExcel() {
      this.loading2019 = true;
      let params = {};
      if (this.type === "Shipped") {
        params = {
          date_from: this.dateFromParam,
          date_to: this.dateToParam,
          xml: "true"
        };
      } else {
        params = {
          prodGroup: this.productGroupParam,
          date_from: this.dateFromParam,
          date_to: this.dateToParam,
          xml: "true"
        };
        if (
          this.type === "top"
            ? this.locationParam && this.locationParam !== "All"
            : true
        ) {
          params.client_location = this.locationParam;
        }
      }
      this.$http
        .get(this.excelDownload, {
          params,
          responseType: "blob"
        })
        .then(
          res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "TableReport.xlsx");
            document.body.appendChild(link);
            link.click();
            this.loading2019 = false;
          },
          err => {
            this.loading2019 = false;
            console.log(err);
          }
        );
    },
    fetchChartDataReceived() {
      let params = {};
      params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.$http.get("api/fns/tables/recieved.php", { params }).then(
        res => {
          this.data = res.data.records;
          console.log(res.data);
          this.total = res.data.records.length;
          res.data.records.forEach(obj => {
            if (obj.price != undefined) {
              this.totalPrice =
                this.totalPrice + parseFloat(obj.price.replace("$", ""));
            }
          });
          this.loading = false;
        },
        err => {
          console.log(err);
        }
      );
    },
    fetchChartDataShipped() {
      let params = {};
      params = {
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        prodModel: this.modelParam
      };
      if (this.locationParam && this.locationParam !== "All") {
        params.client_location = this.locationParam;
      }
      if(this.type === "Shipped")
      {
        this.fields = [
          { key: "fnsid", label: "FNSID", sortable: true },
          { key: "locat", label: "Location" },
          { key: "sernm", label: "Serial#" },
          {
            key: "pMake",
            label: "Manufacturer",
            sortable: true,
            style: "width: 250px"
          },
          { key: "pMode", label: "Model" },
          {
            key: "compl",
            label: "Complaint",
            sortable: true,
            tdClass: "complaintClass"
          },
          { key: "loctn", label: "Status", sortable: true },
          { key: "price", label: "Price", sortable: true }
        ];
        params = {
          date_from: this.dateFromParam,
          date_to: this.dateToParam
        };
      }

      const shippedEndpoint =
        this.type === "Shipped"
          ? "api/fns/tables/shipped-overall.php"
          : "api/fns/tables/shipped.php";
      this.$http.get(shippedEndpoint, { params }).then(
        res => {
          this.data = res.data.records;
          this.total = res.data.records.length;
          res.data.records.forEach(obj => {
            if (obj.price != undefined) {
              let addition = 0;
              obj.price == ""
                ? (addition = 0)
                : (addition = parseFloat(obj.price));
              this.totalPrice = this.totalPrice + addition;
            }
          });

          this.loading = false;
        },
        err => {
          console.log(err);
        }
      );
    },
    fetchChartDataCityPerGroup() {
      let params = {};
      params = {
        client_location: this.locationParam,
        prodGroup: this.prg,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.$http.get("api/fns/tables/shipped.php", { params }).then(
        res => {
          this.data = res.data.records;
          this.total = res.data.records.length;
          res.data.records.forEach(obj => {
            if (obj.price != undefined) {
              this.totalPrice =
                this.totalPrice + parseFloat(obj.price.replace("$", ""));
            }
          });

          this.loading = false;
        },
        err => {
          console.log(err);
        }
      );
    },
    fetchChartDataBer() {
      let params = {};
      params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        prodModel: this.modelParam
      };
      this.$http
        .get("api/fns/tables/ber.php", {
          params
        })
        .then(
          res => {
            this.data = res.data.records;
            console.log(res.data);
            this.total = res.data.records.length;
            res.data.records.forEach(obj => {
              if (obj.price != undefined) {
                this.totalPrice =
                  this.totalPrice + parseFloat(obj.price.replace("$", ""));
              }
            });
            this.loading = false;
          },
          err => {
            console.log(err);
          }
        );
    },
    fetchChartDataEol() {
      let params = {};
      params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.$http
        .get("api/fns/tables/eol.php", {
          params
        })
        .then(
          res => {
            this.data = res.data.records;
            console.log(res.data);
            this.total = res.data.records.length;
            res.data.records.forEach(obj => {
              if (obj.price != undefined) {
                this.totalPrice =
                  this.totalPrice + parseFloat(obj.price.replace("$", ""));
              }
            });
            this.loading = false;
          },
          err => {
            console.log(err);
          }
        );
    },
    fetchChartDataNtf() {
      let params = {};
      params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.$http
        .get("api/fns/tables/ntf.php", {
          params
        })
        .then(
          res => {
            this.data = res.data.records;
            console.log(res.data);
            this.total = res.data.records.length;
            res.data.records.forEach(obj => {
              if (obj.price != undefined) {
                this.totalPrice =
                  this.totalPrice + parseFloat(obj.price.replace("$", ""));
              }
            });

            this.loading = false;
          },
          err => {
            console.log(err);
          }
        );
    },
    fetchChartDataWar() {
      let params = {};
      params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.$http
        .get("api/fns/tables/war.php", {
          params
        })
        .then(
          res => {
            this.data = res.data.records;
            console.log(res.data);
            this.total = res.data.records.length;
            res.data.records.forEach(obj => {
              if (obj.price != undefined) {
                this.totalPrice =
                  this.totalPrice + parseFloat(obj.price.replace("$", ""));
              }
            });

            this.loading = false;
          },
          err => {
            console.log(err);
          }
        );
    },
    fetchChartDataOem() {
      let params = {};
      params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam
      };
      this.$http
        .get("api/fns/tables/oem_backlog.php", {
          params
        })
        .then(
          res => {
            this.data = res.data.records;
            console.log(res.data);
            this.total = res.data.records.length;
            res.data.records.forEach(obj => {
              if (obj.price != undefined) {
                this.totalPrice =
                  this.totalPrice + parseFloat(obj.price.replace("$", ""));
              }
            });

            this.loading = false;
          },
          err => {
            console.log(err);
          }
        );
    },
    fetchChartDataOemShipped() {
      let params = {};
      params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.$http
        .get("api/fns/tables/oem_delivered.php", {
          params
        })
        .then(
          res => {
            this.data = res.data.records;
            console.log(res.data);
            this.total = res.data.records.length;
            res.data.records.forEach(obj => {
              if (obj.price != undefined) {
                this.totalPrice =
                  this.totalPrice + parseFloat(obj.price.replace("$", ""));
              }
            });

            this.loading = false;
          },
          err => {
            console.log(err);
          }
        );
    },
    fetchChartDatabacklog() {
      let params = {};

      params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        prodModel: this.modelParam
      };

      this.$http
        .get("api/fns/tables/back.php", {
          params
        })
        .then(
          res => {
            this.data = res.data.records;
            console.log(res.data);
            this.total = res.data.records.length;
            res.data.records.forEach(obj => {
              if (obj.price != undefined) {
                this.totalPrice =
                  this.totalPrice + parseFloat(obj.price.replace("$", ""));
              }
            });

            this.loading = false;
            console.log(this.$refs);
          },
          err => {
            console.log(err);
          }
        );
    },
    fetchSubBacklog() {
      let params = {};
      params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam
      };
      this.$http
        .get("api/fns/tables/subdivision_backlog.php", {
          params
        })
        .then(
          res => {
            this.data = res.data.records;
            console.log(res.data);
            this.total = res.data.records.length;
            res.data.records.forEach(obj => {
              if (obj.price != undefined) {
                this.totalPrice =
                  this.totalPrice + parseFloat(obj.price.replace("$", ""));
              }
            });

            this.loading = false;
          },
          err => {
            console.log(err);
          }
        );
    },
    fetchSubDelivered() {
      let params = {};
      params = {
        client_location: this.locationParam,
        prodGroup: this.productGroupParam,
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.$http
        .get("api/fns/tables/subdivision_delivered.php", {
          params
        })
        .then(
          res => {
            this.data = res.data.records;
            console.log(res.data);
            this.total = res.data.records.length;
            res.data.records.forEach(obj => {
              if (obj.price != undefined) {
                this.totalPrice =
                  this.totalPrice + parseFloat(obj.price.replace("$", ""));
              }
            });

            this.loading = false;
          },
          err => {
            console.log(err);
          }
        );
    }
  },
  mounted() {
    allowedPath(
      router.currentRoute.path,
      localStorage.getItem("user_tabs"),
      localStorage.getItem("redirect_path")
    );
    if (this.type != "top") {
      this.locationParam = "All";
      this.productGroupParam = "";

      if (this.productModel) {
        this.modelParam = this.productModel.substring(
          0,
          this.productModel.lastIndexOf("(")
        );
      }

      this.title = this.type.toLocaleUpperCase();
    } else {
      this.locationParam = this.location;
      this.productGroupParam = this.prg.substring(0, this.prg.lastIndexOf("("));
      this.title = this.prg + " Shipped to " + this.locationParam;
    }
    this.clientsId = this.clients;
    this.dateFromParam = this.date_from;
    this.dateToParam = this.date_to;

    if (this.type === "Received") {
      this.fetchChartDataReceived();
      this.excelDownload = "api/fns/tables/recieved.php";
    }
    if (this.type === "Shipped") {
      this.fetchChartDataShipped();
      this.excelDownload = "api/fns/tables/shipped-overall.php";
    }
    if (this.type === "top") {
      this.fetchChartDataShipped();
      this.excelDownload = "api/fns/tables/shipped.php";
    }
    if (this.type === "OEM") {
      this.fetchChartDataOem();
      this.excelDownload = "api/fns/tables/oem_backlog.php";
    }
    if (this.type === "OEMShip") {
      this.fetchChartDataOemShipped();
      this.excelDownload = "api/fns/tables/oem_delivered.php";
    }
    if (this.type === "ber") {
      this.fetchChartDataBer();
      this.excelDownload = "api/fns/tables/ber.php";
    }
    if (this.type === "eol") {
      this.fetchChartDataEol();
      this.excelDownload = "api/fns/tables/eol.php";
    }
    if (this.type === "ntf") {
      this.fetchChartDataNtf();
      this.excelDownload = "api/fns/tables/ntf.php";
    }
    if (this.type === "war") {
      this.fetchChartDataWar();
      this.excelDownload = "api/fns/tables/war.php";
    }
    if (this.type === "backlog") {
      this.fetchChartDatabacklog();
      this.excelDownload = "api/fns/tables/back.php";
    }
    if (this.type === "city") {
      this.fetchChartDataCityPerGroup();
      this.excelDownload = "api/fns/tables/shipped.php";
    }
    if (this.type === "SubDivisionBacklog") {
      this.fetchSubBacklog();
      this.excelDownload = "api/fns/tables/subdivision_backlog.php";
    }
    if (this.type === "SubDivisionDelivered") {
      this.fetchSubDelivered();
      this.excelDownload = "api/fns/tables/subdivision_delivered.php";
    }
  }
};
</script>
<style>
.complaintClass {
  width: 200px;
}
.download-button {
  display: inline-block;
  margin: auto;
  float: right;
  font-weight: 500;
  padding: 0.7em;
  font-size: 0.9em;
  border-radius: 0.3rem;
  color: white;
  background: #20a8d8;
}
.bouncing2 {
  height: 20px !important;
  width: 20px !important;
  line-height: 55px;
  margin: auto;
}
.download-button:hover {
  text-decoration: none !important;
  color: white;
}
.fa-file-excel-o {
  font-size: 1em;
  color: #ffffff68;
  transform: rotate(30deg);
  padding-right: 0.5em;
}
</style>
